import { Outlet } from "react-router-dom";

const Operator = () => {
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default Operator;
